<template>
  <main class="configurator">
    <viewport-height
        :max="window.width >= 1200 || window.width >= 1024 && window.width < 1200 && landscape">
      <div class="configurator__wrapper" :class="className">
        <div class="configurator__model">
          <fabricator @handleExpand="handleExpand"></fabricator>

          <div class="configurator__results" v-if="window.width >= 1200">
            <results-list v-if="resultsForView" :results="resultsForView"/>
          </div>
        </div>

        <div class="configurator__sidebar sidebar"
             :style="{ height: landscape ? window.height + 'px' : 'auto' }">
          <dropdown @result="handleResults" />
          <div class="sidebar__button">
            <button-theme
                :mode="`fill`"
                :size="`m`"
                :name="this.$store.state.siteData.global.confirm_selection_btn_text"
                @handleClick="handleClick()"
            />
          </div>
        </div>
      </div>
    </viewport-height>
  </main>
</template>

<script>
import {mapMutations} from 'vuex';
import {mixin} from '../mixin';
// import json from '../../../../assets/data/configurations.json';
import viewportHeight from './components/viewportHeight.vue';
import buttonTheme from './components/buttonTheme.vue';
import dropdown from './components/dropdown.vue';
import fabricator from './components/fabricator.vue';
import resultsList from './components/resultsList.vue';
import axios from "axios";
import * as qs from "qs";

export default {
  name: 'mainElement',
  mixins: [mixin],
  components: {
    fabricator,
    resultsList,
    viewportHeight,
    dropdown,
    buttonTheme,
  },
  data() {
    return {
      // items: json.items,
      actionName: '',
      defaultResults: [],
      localResults: [],
      results: [],
      resultsForView: [],
      landscape: false,
      className: '',
    };
  },

  //For tests file.json
  // async fetch() {
  //   this.items = await fetch(json).then((res) => res.json());
  // },
  // fetchOnServer: false,
  created() {
    // this.resetState();

    if (window) {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  },
  destroyed() {
    if (window) {
      window.removeEventListener('resize', this.handleResize);
    }
  },
  computed: {
    storeItems() {
      return this.$store.getters.storeItems;
    },
    storeResults() {
      return this.$store.state.selectedResult.model;
    },
    product() {
      return this.$store.state.loadProduct;
    },
  },
  mounted() {
    this.handleOrientation();
    window.addEventListener(
        "orientationchange",
        this.handleOrientation
    );

    this.resetState();
  },
  methods: {
    ...mapMutations(['resetState']),
    getNumber(inx) {
      if (inx < 9) {
        return `0${inx + 1}`;
      } else {
        return `${inx + 1}`;
      }
    },
    id(itemName) {
      return itemName.toLowerCase().split(' ').join('-');
    },
    addItem(results, value) {
      const addIt = (item) => {
        const index = results.findIndex((x) => x.id === item.id);

        if (index === -1) {
          results.push(item);
        } else {
          results[index] = item;
        }
      };

      addIt(value);
    },
    // update results for the view on the main page
    showResults(value) {
      this.addItem(this.localResults, value);
      this.resultsForView = [...this.localResults];
    },
    // update results for the store
    updateResults(value) {
      this.addItem(this.storeResults, value);
      this.results = [...this.storeResults];

      this.$store.commit('updateModel', this.results);
    },
    handleResults(value) {
      this.showResults(value);
      this.updateResults(value);
    },
    handleClick() {
      // get model image
      this.sendActionToFabricator('getSnapshotBuffer');
      window.addEventListener("message", (event) => {
        if (typeof event.data === 'string' && event.data.includes('data:image')) {
          this.$store.commit('updateModelImage', event.data);
        }
      }, false);

      // update data
      let data = {action: 'vue_selected_data', selected: this.storeResults};
      axios({
        async: false,
        method: 'post',
        url: app.ajax_url,
        data: qs.stringify(data),
      }).then(response => {
        this.$store.commit('setUrl', response.data);
        this.$router.push({name: 'Share'}).catch(()=>{});
      }).catch(() => {
      });
    },
    sendActionToFabricator(actionName) {
      const fabricator = document.getElementById('fabricator').contentWindow;
      if (fabricator) fabricator.postMessage(actionName, '*');
    },
    handleOrientation() {
      const orientation = (screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation;
      if (orientation) {
        this.landscape = orientation === 'landscape-primary';
      } else {
        console.log(window.orientation, 'window.orientation')
        this.landscape = Math.abs(window.orientation) === 90;
      }
    },
    handleExpand(expand) {
      expand ? this.className = 'has-active' : this.className = '';
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../sass/setup.scss';

.configurator {
  &__wrapper {
    flex-grow: 1;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 100%;
    //grid-template-rows: auto 100%;
    grid-template-rows: calc(42.1333vw + 88px) auto;

    //@include up-tablet {
    //  grid-template-rows: 30.208vw 1fr;
    //}

    @include up-laptop {
      grid-template-columns: 64.1vw 1fr;
      grid-template-rows: 1fr;
      overflow: hidden;
    }

    .touch & {
      @media (min-width: 1024px) and (orientation: landscape) {
        grid-template-columns: 54.1vw 1fr;
        grid-template-rows: 1fr;
        overflow: hidden;
      }

      @include up-laptop {
        grid-template-columns: 64.1vw 1fr;
        grid-template-rows: 1fr;
        overflow: hidden;
      }
    }

    &.has-active {
      grid-template-rows: 127px 1fr;
    }
  }

  &__model {
    position: relative;
    background: $c-beige-gradient;
  }

  &__results {
    position: absolute;
    top: 31px;
    right: 30px;
    width: 19.17vw;
    min-width: 276px;
    background-color: $c-white;

    @include up-tablet {
      padding: 0 16px;
    }
  }

  &__sidebar {
    position: relative;
    z-index: 2;
    //height: fit-content;
    //min-height: 100%;
    background-color: $c-white;
    //overflow-y: auto;
    //scrollbar-color: transparent transparent;
    //scrollbar-width: none;

    @include up-laptop {
      height: 100%;
      overflow-y: auto;
      scrollbar-color: transparent transparent;
      scrollbar-width: none;
    }

    .touch & {
      //@media (max-width: 1199px) and (orientation: portrait) {
      //  height: auto !important;
      //}
      //
      //@media (max-width: 1023px) and (orientation: landscape) {
      //  height: auto !important;
      //}

      @media (min-width: 1024px) and (orientation: landscape) {
        //height: 100%;
        overflow-y: auto;
        scrollbar-color: transparent transparent;
        scrollbar-width: none;
      }

      @include up-laptop {
        //height: 100%;
        overflow-y: auto;
        scrollbar-color: transparent transparent;
        scrollbar-width: none;
      }
    }

    &::-webkit-scrollbar {
      width: 3px;
      height: 3px;
      background: $c-white;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 0;
      background: linear-gradient(180deg, #f7ece2, rgba(247, 235, 225, 0));
    }
  }

  .sidebar {
    display: flex;
    flex-direction: column;

    &__button {
      margin: auto 23px 14px;

      @include up-tablet {
        margin: auto 20px 21px;
      }

      @include up-laptop {
        margin: auto 32px 34px;
      }
    }
  }
}
</style>
